import * as React from 'react'
import Helmet from 'react-helmet'
import TnCAndPNConsent from '../TnCAndPNConsent/TnCAndPNConsent'

function MainView(props) {
  return (
    <>
      <Helmet>
        <style>
          {`.adsbygoogle {
            display: none !important;
          }`}
        </style>
      </Helmet>
      <TnCAndPNConsent />
    </>
  )
}

export default MainView
